import { render } from "./OlabIncubator.vue?vue&type=template&id=56e03130&scoped=true"
import script from "./OlabIncubator.vue?vue&type=script&lang=js"
export * from "./OlabIncubator.vue?vue&type=script&lang=js"

import "./OlabIncubator.vue?vue&type=style&index=0&id=56e03130&scoped=true&lang=css"

import exportComponent from "/Users/ckyang/dev/olabbio/sites/olab-github/gf-olab-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e03130"]])

export default __exports__